export default __webpack_public_path__ + "static/media/english-to-russian-mobile-1.2fab0e1f.png";